export default __webpack_public_path__ + "static/cafe plant-bc36f0cf676316d2bd05f5a4b677e35f.svg";